import { Routes } from "@angular/router";
import { authGuard } from "../core/auth/auth.guard";

export const routes: Routes = [
  {
    path: "",
    loadChildren: () => import("../public/public.routes").then((m) => m.PUBLIC_ROUTES),
  },
  {
    path: "app",
    canActivate: [authGuard],
    loadChildren: () => import("../private/private.routes").then((m) => m.PRIVATE_ROUTES),
  },
  {
    path: "**",
    redirectTo: "",
  },
];
